//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import moment from 'moment'
import 'moment/locale/es'
moment.locale('es')

export default {
    head(){
        return {
            title: this.data.vehicle.title + ' - Focomotor',
            scripts: [
                { hid: 'adsense', src: 'https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js', defer: true, 'data-ad-client': 'ca-pub-5902667990414861' },
            ]
        }
    },
    mounted(){
        this.$nextTick(() => {
        try {
            // this is required for each ad slot (calling this once will only load 1 ad)
            (window.adsbygoogle = window.adsbygoogle || []).push({})
        } catch (error) {
            console.error(error)
        }
        })
    },
    async asyncData({ $axios, params, error }) {
        return await $axios.$get("vehicle/" + params.slug + "?related=true")
            .then((res) => {
                return { data: res };
            })
            .catch(() => error({ status: 404 }));
    },
    methods: {
        formatDate(date) {
        return moment(date).fromNow()
        }
    },
    data() {
        return {
            showMessageModal: false,
            showTelModal: false
        };
    },
};
